
document.addEventListener('DOMContentLoaded', () => {
  // ログインページへ
  const loginPage = document.getElementById("customer__to-login-page");
  const customerInfomation = window.customerData;
  loginPage.addEventListener("click", function () {
      window.location.href = customerInfomation.shopDomain + "/account/login";
  });
});
